<template>
  <div class="role_warp">
    <!-- 头部工具栏 -->
    <div class="role_heard_tool">
      <el-button
        type="success"
        size="mini"
        
        @click="getList"
        >刷新</el-button
      >
      <el-button
        type="primary"
        class="edit-button"
        size="mini"
        style="margin-left: 10px"
        @click="select()"
        >筛选</el-button
      >
        <el-button
      type="primary"
      class="edit-button"
      size="mini"
      style="margin-left: 10px;background:#06CC00;border:1px solid #06CC00;margin-bottom: 5px;font-size: 12px;"
      @click="checkSuccessList(2)"
      >批量通过状态1</el-button
    >
    <el-button
      type="primary"
      class="edit-button"
      size="mini"
      style="margin-left: 10px;background:#06CC00;border:1px solid #06CC00;margin-bottom: 5px;font-size: 12px;"
      @click="approveStatus1and()"
      >批量通过状态2</el-button
    >
    <el-button
      type="primary"
      class="edit-button"
      size="mini"
      style="margin-left: 10px;background:#FF0000;border:1px solid #FF0000;margin-bottom: 5px;"
      @click="checkRejectList(2)"
      >批量拒绝</el-button
    >
    </div>
    <div class="head_search">
      <div class="item_warp">
        <label style="margin: 0 10px;">用户</label>
        <el-input
          v-model="uid"
          placeholder="请输入用户"
          style="width: 120px"
          size="mini"
          clearable
        />
      </div>
      <div class="item_warp">
        <label style="margin: 0 10px;">状态1</label>
        <el-select v-model="status" style="width: 100px;" placeholder="请选择" clearable>
        <el-option label="不限" value=""></el-option>
        <el-option label="审核中" :value="0"></el-option>
        <el-option label="审核成功" :value="1"></el-option>
        <el-option label="审核拒绝" :value="2"></el-option>
        </el-select>
      </div>
      <div class="item_warp">
        <label style="margin: 0 10px;">状态2</label>
        <el-select v-model="status2" style="width: 100px;" placeholder="请选择" clearable>
        <el-option label="不限" value=""></el-option>
        <el-option label="审核中" :value="0"></el-option>
        <el-option label="审核通过" :value="1"></el-option>
        </el-select>
      </div>
      <div class="item_warp">
        <label style="margin: 0 10px">老用户</label>
        <el-select
          v-model="platformMemo"
          style="width: 100px"
          placeholder="请选择"
          clearable
        >
          <el-option label="不限" value=""></el-option>
          <el-option label="全部充值" value="allRecharge"></el-option>
          <el-option label="全部" value="all"></el-option>
          <el-option label="MD" value="MD"></el-option>
          <el-option label="BAM" value="BAM"></el-option>
          <el-option label="HR" value="HR"></el-option>
          <el-option label="ADAS" value="ADAS"></el-option>
          <el-option label="HH" value="HH"></el-option>
          <el-option label="EG" value="EG"></el-option>
          <el-option label="XBK" value="XBK"></el-option>
          <el-option label="XPET" value="XPET"></el-option>
           <el-option label="ZOO" value="ZOO"></el-option>
          <el-option label="MM" value="MM"></el-option>
          <el-option label="FS" value="FS"></el-option>
        </el-select>
      </div>
      <div class="item_warp">
        <label style="margin: 0 10px;">阶段</label>
        <el-select v-model="stage" style="width: 120px" placeholder="请选择" clearable>
        <el-option label="不限" value=""></el-option>
        <el-option label="发帖中" :value="1"></el-option>
        <el-option label="完成任务中" :value="2"></el-option>
        <el-option label="阅读答题中" :value="3"></el-option>
        <el-option label="领取奖励 " :value="4"></el-option>
        <el-option label="没有任务了" :value="5"></el-option>
        </el-select>
      </div>
      <div class="item_warp">
        <label style="margin: 0 10px;">第几轮</label>
        <el-input
          v-model="round"
          placeholder="请输入第几轮"
          style="width: 120px"
          size="mini"
          clearable
        />
      </div>
      <div class="item_warp">
        <label style="margin: 0 10px;">IP数量<=</label>
        <el-input
          v-model="ipCc"
          placeholder="请输入IP数量"
          style="width: 120px"
          size="mini"
          clearable
        />
      </div>
      <div class="item_warp">
        <label style="margin: 0 10px;">国家</label>
        <el-input
          v-model="lastIpAddress"
          placeholder="请输入国家"
          style="width: 120px"
          size="mini"
          clearable
        />
      </div> 
    </div>
    <!-- 表单 -->
    <el-table
      ref="gridTable"
      v-loading="loading"
      :data="tableData"
      tooltip-effect="dark"
      :stripe="true"
      :border="true"
      height="calc(100vh - 240px )"
      style="width: 1601px"
      size="mini"
      @select-all="selectAll"
      @select="selectReceive"
      @selection-change="handleSelectionChange"
    >
     <el-table-column type="selection" width="50" />
     <el-table-column prop="address" label="状态1" width="130">
        <template slot-scope="scoped">
          <div style="display: flex;align-items: center;justify-content: center;" v-if="scoped.row.status == 0">
              <el-button type="success" size="mini" @click="checkSuccessList(1,scoped.row)">通过</el-button>
              <el-button type="danger" size="mini" @click="checkRejectList(1,scoped.row)">拒绝</el-button>
          </div>
          <div style="display: flex;align-items: center;justify-content: center;color:#06CC00" v-if="scoped.row.status == 1">
              已通过
          </div> 
          <div style="display: flex;align-items: center;justify-content: center;color: red;" v-if="scoped.row.status == 2">
              已拒绝
          </div>
        </template>
      </el-table-column> 
      <el-table-column prop="address" label="状态2" width="130">
        <template slot-scope="scoped">
          <div>
            <div style="text-align: start;">
            <el-checkbox v-model="scoped.row.receiveType1">提到余额</el-checkbox>
          </div> 
          <div style="text-align: start;">
            <el-checkbox v-model="scoped.row.receiveType2">提到钱包地址</el-checkbox>
          </div>
          </div> 
          <div>
              <el-button type="info" size="mini"  v-if="scoped.row.stage == 4">审核通过</el-button>
              <el-button type="success" size="mini" v-else @click="approveStage4(scoped.row)">审核中(通过)</el-button>
          </div>
        </template>
      </el-table-column> 
      <el-table-column prop="code" label="推荐码" width="100" />
      <el-table-column prop="address" label="用户" width="100">
        <template slot-scope="scoped">
          <div style="color:#06CC00" v-if="scoped.row.isPlatformRecharge">
            {{ scoped.row.memberUid }}
          </div> 
          <div v-else>
            {{ scoped.row.memberUid }}
          </div>
        </template>
      </el-table-column> 
      <el-table-column prop="withdrawSum" label="配图" width="140">
        <template slot-scope="scoped">
          <div style="display: flex;flex-wrap: wrap;justify-content: center;align-items: center;">
            <el-image style="height: 60px;margin-left: 10px;max-width: 50px;" :src="scoped.row.images[0]+'?x-oss-process=image/resize,w_50'" fit="fill" :preview-src-list="previewImg(scoped.row.images)" @click.stop="handleClickItem"/>
            <span>+{{ scoped.row.images.length }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="address" label="上传历史" width="100">
      <template slot-scope="scope">
        <div>
          <div>
            <el-button type="primary" class="edit-button" size="mini" @click="getChildrenSum(scope.row.historyList)">查看 {{ scope.row.historyList.length }}</el-button>
          </div>
        </div>
      </template>
    </el-table-column>
      <!-- <el-table-column prop="bgt1" label="注册人数" width="100" /> -->
      <el-table-column prop="ipCount" label="IP数量" width="90">
      <template #header>
        <div class="flex">
          <div class="gbRed">
            <div>IP数量</div>
          </div>
          <img
            @click="selectOrder('IP数量', 'asc')"
            v-if="ipCount == 'desc'"
            style="width: 20px; cursor: pointer"
            src="@/img/order_desc.png"
            alt=""
          />
          <img
            @click="selectOrder('IP数量', '')"
            v-if="ipCount == 'asc'"
            style="width: 20px; cursor: pointer"
            src="@/img/order_asc.png"
            alt=""
          />
          <img
            @click="selectOrder('IP数量', 'desc')"
            v-if="ipCount == ''"
            style="width: 20px; cursor: pointer"
            src="@/img/order_no.png"
            alt=""
          />
        </div>
      </template>
    </el-table-column>
      <el-table-column prop="round" label="第几轮" width="100" />
      <el-table-column prop="withdrawSum" label="本轮任务" width="240">
        <template slot-scope="cope">
          <div>
            <div v-if="cope.row.round == 1">
              <div>购买算力 {{ cope.row.round1_1 }}/{{ cope.row.round1_1x }}</div>
              <div>领取收益 {{cope.row.round1_2}}/{{ cope.row.round1_2x }}</div>
            </div>
            <div v-if="cope.row.round == 2">
              <div>Lv1好友 {{ cope.row.round2_1 }}/{{ cope.row.round2_1x }}</div>
              <div>好友购买人数 {{cope.row.round2_2}}/{{ cope.row.round2_2x }}</div>
            </div>
            <div v-if="cope.row.round == 3">
              <div>Lv2-10好友 {{ cope.row.round3_1 }}/{{ cope.row.round3_1x }}</div>
              <div>好友购买人数 {{cope.row.round3_2}}/{{ cope.row.round3_2x }}</div>
            </div>
            <div v-if="cope.row.round == 4">
              <div>本人投资算力 {{ cope.row.round4_1 }}/{{ cope.row.round4_1x }}USDT</div>
            </div>
            <div v-if="cope.row.round == 5">
              <div>Lv1好友投资≥30USDT</div>
              <div>{{cope.row.round5_1}}/{{cope.row.round5_1x}}</div>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="c1" label="下级数量" width="120">
        <template #header>
        <div class="flex">
          <div class="gbRed">
            <div>下级数量</div>
          </div>
          <img
            @click="selectOrder('下级数量', 'asc')"
            v-if="c1 == 'desc'"
            style="width: 20px; cursor: pointer"
            src="@/img/order_desc.png"
            alt=""
          />
          <img
            @click="selectOrder('下级数量', '')"
            v-if="c1 == 'asc'"
            style="width: 20px; cursor: pointer"
            src="@/img/order_asc.png"
            alt=""
          />
          <img
            @click="selectOrder('下级数量', 'desc')"
            v-if="c1 == ''"
            style="width: 20px; cursor: pointer"
            src="@/img/order_no.png"
            alt=""
          />
        </div>
      </template>
      <template slot-scope="scope">
        <div style="text-align: start;">
          <div>总注册 {{ scope.row.totalChildrenCount }}</div>
          <div>非同IP {{ scope.row.childrenIpCount }}</div>
          <div>今日注册 {{ scope.row.todayChildrenCount }}</div>
          <div>今日非同IP {{ scope.row.todayChildrenIpCount }}</div>
        </div>
      </template>
    </el-table-column>
      <el-table-column prop="ra" label="已领取" width="90" />
      <el-table-column prop="address" label="IP" width="170">
      <template slot-scope="scope">
        <div>
          <div>{{ scope.row.lastIp }}</div>
          <div>{{ scope.row.lastIpAddress }}</div>
        </div>
      </template>
     </el-table-column>
     <el-table-column prop="stageStr" label="阶段" width="100" />
     
      <el-table-column prop="address" label="领取状态" width="100">
        <template slot-scope="scoped">
          <div style="display: flex;align-items: center;justify-content: center;color:#06CC00" v-if="scoped.row.receiveStatus == 1">
            已领取 
          </div> 
          <div style="display: flex;align-items: center;justify-content: center;color: #999;" v-if="scoped.row.receiveStatus == 0">
            未领取
          </div>
        </template>
      </el-table-column> 
      <el-table-column prop="platformMemo" label="老用户" width="100" />
      
      <el-table-column prop="lastUploadDate" label="上一次上传时间" width="170">
          <template slot-scope="scoped">
              <div  v-if="scoped.row.lastUploadDate">
              {{ happenTimeFun(scoped.row.lastUploadDate) }}
           </div>
        </template>
      </el-table-column>
      <el-table-column prop="createDate" label="创建时间" width="170" />
      <el-table-column prop="yf" label="乙方" width="100" />
    </el-table>
    <!-- 分页 -->
    <pagination
      v-show="total > 0"
      :total="total"
      :page.sync="pageNum"
      :limit.sync="pageSize"
      @pagination="getList"
    />
    <el-dialog
    :visible.sync="edit_dialogVisible"
    width="500px"
    title="上传历史"
    :center="true"
    :close-on-click-modal="false"
    @close="closeIsEnabled()"
  >
    <!-- 编辑用户表格 -->
    <div>
      <div v-for='(item,index) in historyList' :key='index'>
        <div style="display: flex;align-items: center;">{{item.createDate }} <span v-if='item.status == 2' style="color: red;margin-left: 5px;">已拒绝</span> </div>
        <div style="display: flex;flex-wrap: wrap;margin: 10px 0;">
              <el-image style="height: 60px;margin-left: 10px;max-width: 50px;" v-for="(itm,ind) in item.images" :key="ind" :src="itm" fit="fill" :preview-src-list="item.images" @click.stop="handleClickItem"/>
          </div>
      </div>
    </div>
  </el-dialog>
  </div>
</template>

<script>
import Pagination from "@/components/Pagination"; // 引入分页器
import UploadImage from "@/components/Upload/UploadPic"; // 引入分页器
import VueUeditorWrap from 'vue-ueditor-wrap' // ES6 Module

import validEmail from "@/utils/validate"; // 引入邮箱验证方法
import md5 from "js-md5"; // 引入Md5加密

export default {
  name: "Management",
  components: { Pagination,VueUeditorWrap,UploadImage },
  data() {
    return {
      option: "", // 初始选项
      options: [], // 选择角色
      name: "", // 搜索的管理员名称
      tableData: [], // 展示的表单信息
      // 添加表单
      active: {},
      // 修改表单
      editForm: { },
      total: 0, // 总数
      pageNum: 1, // 页码值
      pageSize: 20, // 页大小
      historyList: [], // 选中项s
      yiFangDetailList: [], // 
      dialogVisible: false, // 添加弹窗
      dialog: false, // 添加弹窗
      edit_dialogVisible: false, // 编辑弹窗
      Isedit: false, // 是否是编辑弹窗
      loading: false, // 表格加
      buttongLoding: false, // 按钮加载
      sn:'',
      lang:'en',
      isEnabled:false,
      isChat:false,
      isTelegram:false,
      isWhatsApp:false,
      isMessenger:false,
      isLinkUrl:false,
      isTelegramGroup:false,
      dialogVisibleUpdate:false,
      dataTime:['',''],
      yifangId:'',
      status:'',
      status2:'',
      ipCount:'',
      c1:'',
      uid:'',
      stage:'',
      round:'',
      ipCc:'',
      lastIpAddress:'',
      platformMemo:"",
      num:0
      
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
  getChildrenSum(row) {
    this.historyList = row;
    this.edit_dialogVisible = true
  },
  previewImg(list){
    let list1 = []
    list.forEach(item => {
      list1.push(item+'?x-oss-process=image/resize,w_450')
    })
    return list1
  },
    handleClickItem() {
      this.$nextTick(() => {
        // 获取遮罩层dom
        const domImageMask = document.querySelector('.el-image-viewer__mask')
        if (!domImageMask) {
          return
        }
        domImageMask.addEventListener('click', () => {
          // 点击遮罩层时调用关闭按钮的 click 事件
          document.querySelector('.el-image-viewer__close').click()
        })
      })
    },
    // 筛选
    select() {
      this.pageNum = 1;
      this.getList();
    },
  approveStatus1and(){
    if (!this.multipleSelection || this.multipleSelection.length < 1) {
          return this.$message.info("你并没有选中任何选项");
        }
    this.$confirm("是否批量审核通过?", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    }).then(() => {
      var ids = [];
    this.multipleSelection.forEach((item) => {
      ids.push({
        id:item.id,
        receiveType1:item.receiveType1,
        receiveType2:item.receiveType2
      });
    });
    var params = ids;
    console.log(params)
    this.$api.operate
      .approveStatus1and(params)
      .then((res) => {
        this.$message.success(res);
      })
      .catch((err) => {
        this.$message.error(err || "服务器错误，请稍后重试");
      })
      .finally(() => {
        this.getList();
      });
        
    })
  },
    // 批量审核通过
  checkSuccessList(type,row){
      if(type == 1){
          var ids = [row.id];
          var params = {
             ids: ids.toString(),
          };
    this.$api.operate
      .approveList(params)
      .then((res) => {
        this.$message.success(res);
      })
      .catch((err) => {
        this.$message.error(err || "服务器错误，请稍后重试");
      })
      .finally(() => {
        this.getList();
      });

      }
      if(type == 2){
        if (!this.multipleSelection || this.multipleSelection.length < 1) {
          return this.$message.info("你并没有选中任何选项");
        }
    this.$confirm("是否批量审核通过?", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    }).then(() => {
      var ids = [];
    this.multipleSelection.forEach((item) => {
      ids.push(item.id);
    });
    var params = {
      ids: ids.toString(),
    };
    this.$api.operate
      .approveList(params)
      .then((res) => {
        this.$message.success(res);
      })
      .catch((err) => {
        this.$message.error(err || "服务器错误，请稍后重试");
      })
      .finally(() => {
        this.getList();
      });
        
    })

      }
  },
  approveStage4(row){
    var params = {
      receiveType1: row.receiveType1,
      receiveType2: row.receiveType2,
      ids: row.id
    };
    this.$api.operate 
      .approveStage(params)
      .then((res) => { 
        this.$message.success(res);
      })
      .catch((err) => {
        this.$message.error(err || "服务器错误，请稍后重试");
      })
      .finally(() => {
        this.getList();
      }); 
  },
  checkRejectList(type,row){
      if(type == 1){
          var ids = [row.id];
          var params = {
             ids: ids.toString(),
          };
    this.$api.operate
      .rejectList(params)
      .then((res) => {
        this.$message.success(res);
      })
      .catch((err) => {
        this.$message.error(err || "服务器错误，请稍后重试");
      })
      .finally(() => {
        this.getList();
      });

      }
    if(type == 2){
      if (!this.multipleSelection || this.multipleSelection.length < 1) {
      return this.$message.info("你并没有选中任何选项");
    }
    this.$confirm("是否批量审核拒绝?", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    }).then(() => {
      var ids = [];
    this.multipleSelection.forEach((item) => {
      ids.push(item.id);
    });
    var params = {
      ids: ids.toString(),
    };
    this.$api.operate
      .rejectList(params)
      .then((res) => {
        this.$message.success(res);
      })
      .catch((err) => {
        this.$message.error(err || "服务器错误，请稍后重试");
      })
      .finally(() => {
        this.getList();
      });
        
    }).catch(() => {
      
      });
    }
  },
  selectOrder(name, type) {
    this.myAmount = "";
    this.c1 = "";
    this.inviteCount = "";
    if (name == "IP数量") {
      this.ipCount = type;
    }
    if (name == "下级数量") {
      this.c1 = type;
    }

    this.pageNum = 1;
    this.getList();
  },
    // 获取表单信息
    getList() {
      var params = {
        pageNumber: this.pageNum,
        pageSize: this.pageSize,
        uid:this.uid,
        status:this.status,
        status2:this.status2,
        ipCount:this.ipCount,
        c1:this.c1,
        stage:this.stage,
        round:this.round,
        ipCc:this.ipCc,
        lastIpAddress:this.lastIpAddress,
        platformMemo:this.platformMemo
      };
      this.loading = true;
      this.$refs.gridTable.bodyWrapper.scrollTop = 0;
        this.$api.operate
        .memberShareRecordList(params)
        .then((res) => {
          this.tableData = res.records;
          this.total = res.total;
        })
        .catch((err) => {
          this.$message.error(err || "服务器错误，请稍后重试");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 选择或者取消行，支持全选
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    selectAll(selection,row){
      var ids = [];
      this.multipleSelection.forEach((item) => {
        ids.push(item.id);
      });
      if(ids.length > 1){
        this.num = this.num + 1
        console.log(this.num%2)
        this.tableData.forEach(item =>{
          if(this.num%2 == 0){
            item.receiveType1 = true
          item.receiveType2 = false

          }else{
            item.receiveType1 = true
          item.receiveType2 = true
          }
          
        })

      }else {
        this.tableData.forEach(item =>{
          item.receiveType1 = false
          item.receiveType2 = false
         })
      }
    },
    selectReceive(selection,row){
      if(selection.length > 0){
        this.tableData.forEach(item =>{
          if(row.id == item.id){
          item.receiveType1 = true
          item.receiveType2 = true
        }
        })

      }else {
        this.tableData.forEach(item =>{
          if(row.id == item.id){
          item.receiveType1 = false
          item.receiveType2 = false
        }
         })
      }
    },
    // 关闭添加弹窗
    handleClose() {
      this.$refs.active.resetFields();
    },
    // 关闭修改弹窗
    editClose(done) {
      this.editInfo = {};
      done();
    },
    // 删除选中项
    handleDel() {
      var ids = [];
      this.multipleSelection.forEach((item) => {
        ids.push(item.id);
      });
      var params = {
        ids: ids.toString(),
      };
      this.$api.operate
        .bannerDelete(params)
        .then((res) => {
          this.$message.success(res);
        })
        .catch((err) => {
          this.$message.error(err || "服务器错误，请稍后重试");
        })
        .finally(() => {
          this.getList();
        });
    },
    happenTimeFun(num){
    let date = new Date(num);
    //时间戳为10位需*1000，时间戳为13位的话不需乘1000
    let y = date.getFullYear();
    let MM = date.getMonth() + 1;
    MM = MM < 10 ? ('0' + MM) : MM; //月补0
    let d = date.getDate();
    d = d < 10 ? ('0' + d) : d; //天补0
    let h = date.getHours();
    h = h < 10 ? ('0' + h) : h; //小时补0
    let m = date.getMinutes();
    m = m < 10 ? ('0' + m) : m; //分钟补0
    let s = date.getSeconds();
    s = s < 10 ? ('0' + s) : s; //秒补0
    return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s
},
    // 添加用户
    bannerSave() {
          this.$api.operate
            .bannerSave(this.active)
            .then((res) => {
              this.$message.success(res);
              this.dialogVisible = false;
              this.getList();
            })
            .catch((err) => {
              this.$message.error(err || "服务器错误，请稍后重试");
            })
            .finally(() => {
              this.buttongLoding = false;
            });
    },
    // 打开删除弹窗
    openDelete() {
      if (!this.multipleSelection || this.multipleSelection.length < 1) {
        return this.$message.info("你并没有选中任何选项");
      }
      this.$confirm("是否删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.handleDel();
        })
        .catch(() => {
          
        });
    },
   
  },
};
</script>
<style lang="scss" scoped>
.role_warp {
  font-size: 14px;
  padding: 10px;
  box-sizing: border-box;
  .role_heard_tool {
    margin-bottom: 10px;
  }
  .edit_titile {
    .dialog_input {
      // width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-around;
      width: 70%;
      span {
        flex: 1;
        display: flex;
        justify-content: flex-end;
        margin-right: 20px;
      }
      .el-input {
        flex: 3;
      }
    }
  }
  .tree {
    margin-top: 25px;
    display: flex;
    justify-content: space-around;
  }
  .authority_info {
    margin-top: 25px;
  }
}
.el-input {
  width: 70%;
}
::v-deep .el-pagination{
white-space: wrap !important;
}
</style>
